(function(){
"use strict";
/* Allinea la soglia batteria dichiarata: 82% al posto di 85%.
   Agisce sulle sezioni DEMA gia' costruite, senza duplicare i contenuti. */
function fix(root){
 if(!root)return;
 var w=document.createTreeWalker(root,NodeFilter.SHOW_TEXT,null);
 var n,changed=[];
 while(n=w.nextNode()){
  if(n.nodeValue&&n.nodeValue.indexOf("85%")>-1)changed.push(n);
 }
 changed.forEach(function(t){
  t.nodeValue=t.nodeValue.replace(/85%/g,"82%").replace(/l'82%/g,"l'82%");
 });
}
function run(){
 fix(document.getElementById("demaSec"));
 fix(document.getElementById("demaBuy"));
 [].forEach.call(document.querySelectorAll(".dema-modal"),fix);
}
run();
[400,1000,1800,3000].forEach(function(ms){setTimeout(run,ms)});
document.addEventListener("click",function(){setTimeout(run,120)},true);
})();
